export default __webpack_public_path__ + "img/logoadfaber.43bf7aab.png";